import React, { useState } from 'react';
import { Spinner } from './Spinner'

export const LabelTituloGeneral = ({titulo, clases = ''}) => {
    return (
        <label className={`text-[#00A0DF] text-[25px] underline ${clases}`}>{titulo}</label>
    )
}